import { createReducer, on } from '@ngrx/store';
import { VanState } from '../models/van.model';
import { logoutSuccess } from 'src/app/core/store/user/user.actions';
import * as VanActions from './van.actions';
import { initialState } from './van.state';

export const vanReducer = createReducer(
  initialState,

  on(logoutSuccess, () => initialState),

  // Load User Vans
  on(VanActions.loadVans, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.loadVansSuccess, (state, { vans }) => ({
    ...state,
    vans,
    loading: false,
    error: null,
  })),

  on(VanActions.loadVansFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Van
  on(VanActions.loadVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.loadVanSuccess, (state, { van }) => {
    // Find if the van already exists in the array
    const vanExists = state.vans.some((v) => v.id === van.id);

    return {
      ...state,
      // If the van doesn't exist, add it to the array
      vans: vanExists
        ? state.vans.map((v) => (v.id === van.id ? van : v))
        : [...state.vans, van],
      loading: false,
      error: null,
    };
  }),

  on(VanActions.loadVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Van
  on(VanActions.createVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.createVanSuccess, (state, { van }) => ({
    ...state,
    vans: [...state.vans, van],
    loading: false,
    error: null,
  })),

  on(VanActions.createVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Van
  on(VanActions.updateVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.updateVanSuccess, (state, { van }) => ({
    ...state,
    vans: state.vans.map((v) => (v.id === van.id ? van : v)),
    loading: false,
    error: null,
  })),

  on(VanActions.updateVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Van
  on(VanActions.deleteVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.deleteVanSuccess, (state, { vanId }) => ({
    ...state,
    vans: state.vans.map((van) =>
      van.id === vanId ? { ...van, state: 'deleted' as VanState } : van
    ),
    loading: false,
    error: null,
  })),

  on(VanActions.deleteVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Archive Van
  on(VanActions.archiveVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.archiveVanSuccess, (state, { van }) => ({
    ...state,
    vans: state.vans.map((v) => (v.id === van.id ? van : v)),
    loading: false,
    error: null,
  })),

  on(VanActions.archiveVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Restore Van
  on(VanActions.restoreVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.restoreVanSuccess, (state, { van }) => ({
    ...state,
    vans: state.vans.map((v) => (v.id === van.id ? van : v)),
    loading: false,
    error: null,
  })),

  on(VanActions.restoreVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Share Van
  on(VanActions.shareVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.shareVanSuccess, (state, { van }) => ({
    ...state,
    vans: state.vans.map((v) => (v.id === van.id ? van : v)),
    loading: false,
    error: null,
  })),

  on(VanActions.shareVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Unshare Van
  on(VanActions.unshareVan, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(VanActions.unshareVanSuccess, (state, { van }) => ({
    ...state,
    vans: state.vans.map((v) => (v.id === van.id ? van : v)),
    loading: false,
    error: null,
  })),

  on(VanActions.unshareVanFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
